import { render } from "./AccountRequest.vue?vue&type=template&id=79d2326e"
import script from "./AccountRequest.vue?vue&type=script&lang=js"
export * from "./AccountRequest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__